module.exports = __webpack_public_path__ + "static/hotel-website@2x-d3eb51e790ba854d830efcf5fb66c76a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/examples/hotel-website@2x.jpg
// module id = 879
// module chunks = 71833740541355 256871573202158